import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { useMindlerApi } from "api/apiv2";
import { useTranslation } from "react-i18next";
import PatientItem from "./patientItem";

export const SavedCardStatus = ({
  patientUserId,
}: {
  patientUserId?: string | number;
}) => {
  const { t } = useTranslation();

  const api = useMindlerApi();
  const { data: billingDetails, isLoading } = useQuery(
    api.admin.getPatientBillingDetails.queryOptions(
      {
        patientUserId: Number(patientUserId),
      },
      { enabled: !!patientUserId },
    ),
  );

  const hasSavedCard =
    billingDetails &&
    "details" in billingDetails &&
    (billingDetails.details as { defaultPaymentMethodEnabled?: boolean } | null)
      ?.defaultPaymentMethodEnabled === true;

  const displayValue = isLoading
    ? t("FETCHING")
    : hasSavedCard
      ? t("YES")
      : t("NO");

  return <PatientItem title={t("HAS_SAVED_CARD")} value={displayValue} />;
};
